import { normalizedFilters, normalizedTags } from '@/mock/mock-reporting-filter-data.js';
import { defaultComparisonType } from '@/data/filterData';

export default class FilterService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.filterableCols = {
      nonConnectedCallCount: { filterField: 'hasConnected', tagId: 'Call:hasConnected', value: 'no' },
      connectedCallCount: { filterField: 'hasConnected', tagId: 'Call:hasConnected', value: 'yes' },
      payoutCount: { filterField: 'hasPayout', tagId: 'Performance:hasPayout', value: 'yes' },
      conversionAdjustedCalls: { filterField: 'wasConversionAdjusted', tagId: 'Adjustment:wasConversionAdjusted', value: 'yes' },
      payoutAdjustedCalls: { filterField: 'wasPayoutAdjusted', tagId: 'Adjustment:wasPayoutAdjusted', value: 'yes' },
      duplicateCalls: { filterField: 'isDuplicate', tagId: 'Performance:isDuplicate', value: 'yes' },
      incompleteCalls: { filterField: 'isIncomplete', tagId: 'Call:isIncomplete', value: 'yes' },
      convertedCalls: { filterField: 'hasConverted', tagId: 'Performance:hasConverted', value: 'yes' },
      blockedCalls: { filterField: 'wasBlocked', tagId: 'Performance:wasBlocked', value: 'yes' }
    };
  }

  getAvailableFilters() {
    // return this.$http.get(`${FILTER_API_URL}/${accountId}`);

    // The following is to mock the data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([...normalizedFilters, ...normalizedTags]);
      }, 500);
    });
  }

  getNewOrFilterCondition(tagId = '', columnName = '') {
    return {
      tagId: tagId,
      value: '',
      filterField: columnName,
      comparisonTypeTemp: {
        ...defaultComparisonType
      },
      isBulkTag: false,
      hasMultipleValues: false
    }; }

  getNewAndFilterCondition(tagId = '', columnName = '') {
    return {
      tagCriteria: [this.getNewOrFilterCondition(tagId, columnName)],
      key: Math.random()
    };
  }
  
  getFilterableCol(colId) {
    return this.filterableCols[colId];
  }

  // #getBaseUrl(accountId) {
  //   return `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/reporting/filters`;
  // }
}